import { throttle } from 'underscore';

const throttledInvalidate = throttle(async (queryClient) => {
  await queryClient.invalidateQueries({
    predicate: (query) => query.queryKey[0] === 'assigned_tasks_list'
  });
}, 2000);

export const assignedTasksRefresh = async (settings, queryClient) => {
  throttledInvalidate(queryClient);
};